import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';

const Logo = ({limage, dimage, simage, isSticky}) => {
    const location = useLocation();
    const { theme } = useTheme();
    
    // Check if we're on home page
    const isHomePage = location.pathname === process.env.PUBLIC_URL + "/" || location.pathname === "/";
    
    const isDarkMode = theme === 'dark';
    
    // Determine which logo to show
    const getLogoSource = () => {
        // Dark mode: always use 1.png
        if (isDarkMode) {
            return "/images/1.png";
        }
        
        // Home page + navbar on top: use 1.png
        if (isHomePage && !isSticky) {
            return "/images/1.png";
        }
        
        // Home page + navbar scrolled down (sticky): use 3.png
        if (isHomePage && isSticky) {
            return "/images/3.png";
        }
        
        // Other pages (not home) + white mode + navbar on top: use 3.png
        if (!isHomePage && !isSticky) {
            return "/images/3.png";
        }
        
        // Other pages (not home) + white mode + navbar scrolled down (sticky): use 3.png
        if (!isHomePage && isSticky) {
            return "/images/3.png";
        }
        
        // Default: use 1.png
        return "/images/1.png";
    };
    
    const logoSource = getLogoSource();
    
    return (
        <Link to="/" style={{display: 'inline-block'}}>
            <img 
                className="logo-image" 
                src={process.env.PUBLIC_URL + logoSource} 
                alt="FielCarga Logo"
                style={{
                    maxHeight: '60px',
                    width: 'auto',
                    height: 'auto',
                    objectFit: 'contain'
                }}
            />
            <style jsx>{`
                .logo-image {
                    max-height: 60px !important;
                    max-width: 200px !important;
                    width: auto !important;
                    height: auto !important;
                    object-fit: contain !important;
                }
                @media (max-width: 991px) {
                    .logo-image {
                        max-height: 50px !important;
                        max-width: 160px !important;
                    }
                }
            `}</style>
        </Link>
    )
}

export default Logo;